<template>
  <div class="nav-bottom-page" :class="!showbar?'display-none':''">
    <div class="nav-bottom-page-content flex-row-center">
      <div class="logo">
        <img src="../../assets/img/icon-nav-bottom-logo.png">
      </div>
      <div class="text">
        <p class="font-12">{{ str0 }}</p>
        <p class="font-12">{{ str1 }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showbar: true,
      str0: '人民永远是靠山——吕正操革命精神研学中心　　技术提供：北京爱迪科森教育科技股份有限公司　　技术支持：010-82676268',
      str1: '版权所有 ：保定学院图书馆　　地址：河北省保定市七一东路3027号　　电话：0312-5972155 5972057　　电邮：lib@bdu.edu.cn　　邮编：071000'
    }
  },
  watch: {
    $route(to, from) {
      this.matchRouter(to.fullPath)
    }
  },
  created() {
    this.matchRouter(this.$router.currentRoute.fullPath)
  },
  methods: {
    matchRouter(path) {
      this.showbar = true
      if (path.indexOf('audio') >= 0 || path.indexOf('libvr') >= 0) {
        this.showbar = false
      }
    }
  }
}
</script>

<style  lang="scss" scoped>
  .nav-bottom-page {
    width: 100%;
    height: 150px;
    background-color: #222;
  }

  .nav-bottom-page-content {
    width: 1220px;
    margin: 0 auto;
    height: 120px;
  }

  .nav-bottom-page-content p {
    color: rgba(255, 255, 255, 0.5);
    line-height: 22px;
  }

  .display-none {
    display: none;
  }
</style>
